<template>
<div class="main-header-con">
    <div class="main-header">
        <div class="head-content">
            <div class="header-left">
                <div class="img-wrap" v-if="logoPath!=''">
                    <img :src="`${logoPath}?${timestamp}`" width="100%" height="100%" />
                </div>
                <span v-if="topHeaderName.length==0">{{logoTitle}}数据看板</span>
                <span v-else>{{logoTitle}}数据看板—{{topHeaderName}}</span>
            </div>
            <div class="header-avator-con" v-show="name">
                <div class="user-dropdown-menu-con">
                    <Row type="flex" justify="end" align="middle" :class="userInfoStyle">
                        <Dropdown transfer>
                            <a href="javascript:void(0)" class="down-a">
                                <span class="main-user-name">{{ name }}</span>
                                <Icon type="md-arrow-dropdown" class="down-icon" />
                            </a>
                            <DropdownMenu slot="list">
                                <DropdownItem name="loginout" @click.native="logout" divided>退出登录</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <Avatar :src="userHeadImg" style="background: #619fe7;margin-left: 10px;" size="large"></Avatar>
                    </Row>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    name: "top-header",
    computed: {
        ...mapGetters([
            'schoolName',
            'userHeadImg',
            'name',
            'topHeaderName'
        ])
    },
    data() {
        return {
            theme1: "primary",
            userInfoStyle: 'user-dropdown-innercon',
            logoPath: process.env.VUE_APP_MAIN_LOGO_PATH,
            logoTitle: process.env.VUE_APP_LOGO_TITLE,
            timestamp: (new Date()).getTime()
        }
    },
    methods: {
        selectMenuStats(menuType) {
            this.$router.push({
                name: menuType
            });
        },
        // 退出
        logout() {
            let that = this;
            that.$Modal.confirm({
                title: '提示',
                content: '<p>确认退出吗?</p>',
                onOk: () => {
                    let isInsideUse = this.$utils.getCookie("isInsideUse");
                    //清除所有cookie
                    that.clearCookie();
                    ssoClient.logout(process.env.VUE_APP_DOMAIN);
                    //修改ie下无法跳转的问题
                    // window.location.href = '/login';
                    // window.location.href = '/bigdatamge/login';
                },
                onCancel: () => {}
            });
        },
        /**
         * 清除cookie
         */
        clearCookie() {
            this.$utils.clearCookieByPaths([
                "token",
                "userid",
                "realname",
                "schoolid",
                "schoolName",
                "schoolType",
                "admin_type",
                "userType",
                "userLoginType",
                "isInsideUse",
                "agentId",
                "agentName"
            ]);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../style/home";

/*.ivu-menu-horizontal {*/
/*height      : 70px;*/
/*line-height : 70px;*/
/*}*/
.down-a {
    display: flex;
    justify-content: center;
    align-items: center;

    .down-icon {
        font-size: 20px;
        color: #fff;
    }
}
</style>
<style lang="scss">
.ivu-layout-header {
    background: #515a6e;
    padding: unset !important;
    height: unset !important;
    line-height: unset !important;
}
</style>
